import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import { initHighcharts } from './highcharts';


import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
	key: 'a3a2a1791fc3ed8af159859bb541b841',
	securityJsCode: '3d100b36888d0ccc57867a8dde6ed36b', // 新版key需要配合安全密钥使用
	v: "1.4.15",
  uiVersion: "1.0.11"
  // Loca:{
	//  version: '2.0.0'
	// } // 如果需要使用loca组件库，需要加载Loca
});
import '@/permission' // permission control

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false

initHighcharts();
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
